import styled from 'styled-components';

const ButtonPanel = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 5px;
`;

export default ButtonPanel;
